import { normalize, denormalize } from 'normalizr';
import { combineEpics, ofType } from 'redux-observable';
import {
  switchMap, catchError, mergeMap, map,
} from 'rxjs/operators';
import api from 'api/index';
import { handleError } from 'base/errors/store/actions';
import * as actionTypes from './actionTypes';
import { roleSchema, rolesSchema } from '../../../store/schema';
import {
  createRoleSuccess,
  deleteRoleSuccess,
  fetchAllRolesSuccess,
  updateRoleSuccess,
  fetchAllSpaceRolesSuccess,
} from './actions';
import { entitiesFetchSuccess } from '../../../store/entities/actions';
import { getEntities } from '../../../store/entities/selectors';


const fetchAll = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL),
  switchMap(() => api.roles.fetchAll().pipe(
    map((response) => normalize(response.body, rolesSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllRolesSuccess(result),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);

const fetchAllSpaceMembers = (action$) => action$.pipe(
  ofType(actionTypes.FETCH_ALL_SPACE_MEMBERS),
  switchMap((action) => api.roles.fetchAllBySpaceId(action.spaceId).pipe(
    map((response) => normalize(response.body, rolesSchema)),
    mergeMap(({ entities, result }) => [
      entitiesFetchSuccess(entities),
      fetchAllSpaceRolesSuccess(result, action.spaceId),
    ]),
    catchError((error) => [handleError(error)]),
  )),
);


const createRole = (action$, state$) => action$.pipe(
  ofType(actionTypes.CREATE),
  switchMap((action) =>
    api.roles.create(denormalize(action.role, roleSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, roleSchema);
        return [
          entitiesFetchSuccess(entities),
          createRoleSuccess(response.body),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),
);


const updateRole = (action$, state$) => action$.pipe(
  ofType(actionTypes.UPDATE),
  switchMap((action) =>
    api.roles.update(denormalize(action.role, roleSchema, getEntities(state$.value))).pipe(
      mergeMap((response) => {
        const { entities } = normalize(response.body, roleSchema);
        return [
          entitiesFetchSuccess(entities),
          updateRoleSuccess(action.role.id),
        ];
      }),
      catchError((error) => [handleError(error)]),
    )),
);


const deleteRole = (action$) => action$.pipe(
  ofType(actionTypes.DELETE),
  switchMap((action) => api.roles.delete(action.role).pipe(
    mergeMap(() => [
      deleteRoleSuccess(action.role.id),
    ]),
    catchError((error) => [handleError(error)]),
  )),

);

export default combineEpics(
  fetchAll,
  fetchAllSpaceMembers,
  createRole,
  updateRole,
  deleteRole,
);
